<script>
	import Post from "./Post.svelte";
	import { store } from "../store.js";
	// console.log($store.posts[$$props.id].cg_posts_groupped);
</script>

<div
	class="cs_post_list {$store.options[$$props.id].loading == 'true'
		? 'loading'
		: 'loaded'}"
>
	{#if $store.posts[$$props.id].cg_posts_groupped && $store.posts[$$props.id].post_count > 0}
		{#each Object.entries($store.posts[$$props.id].cg_posts_groupped) as [title, postsList], i}
			<div class="cg_posts_group">
				<span class="cg_posts_group_title">{title}</span>
				<div class="cg_posts_group_posts">
					{#each $store.posts[$$props.id].cg_posts_groupped[title] as post, i}
						<Post {post} id={$$props.id} />
					{/each}
				</div>
			</div>
		{/each}
	{:else if $store.posts[$$props.id].post_count == 0}
		<p class="cs_nopublications cs_message">
			Aucune publication ne correspond à vos filtres
		</p>
	{/if}
</div>
